import { LANGUAGES } from './constants';
import { getDataHost } from './get-data-host';
const fetchJson = async (url) => {
    let response = {};
    let data = {};
    let error = {};
    let loading = true;
    try {
        response = await fetch(url);
        data = await response.json();
    }
    catch (e) {
        error = e;
    }
    loading = false;
    if (!(error instanceof Error) && Object.keys(data).length === 0) {
        error = {
            name: 'Parse error',
            message: 'The document could not be parsed',
        };
    }
    return { loading, error, data };
};
const initialize = async ({ broadcastError, config: { locale = 'en', isBrewery = false }, }) => {
    var _a, _b;
    const { hostname } = (_b = (_a = global.window) === null || _a === void 0 ? void 0 : _a.location) !== null && _b !== void 0 ? _b : {
        hostname: 'localhost',
    };
    const dataVersion = 1;
    const dataHost = getDataHost(hostname, isBrewery);
    const lang = (locale && LANGUAGES[locale]) || 'en';
    const dataUrl = `${dataHost}/frame/meta.v${dataVersion}.${lang}.json`;
    const { loading, error, data } = await fetchJson(dataUrl);
    if (error instanceof Error) {
        broadcastError(error, 'The fetch call for frame meta has returned an error!');
    }
    return {
        data: { metaConfigData: { url: dataUrl, version: dataVersion, ...data } },
        meta: {
            loading,
            error,
        },
    };
};
const getHooks = (useFrameHooks) => {
    const useMetaConfig = () => {
        const { useFrameContext } = useFrameHooks();
        const { metaConfigData, loading, error } = useFrameContext();
        return { loading, data: metaConfigData, error };
    };
    return { useMetaConfig };
};
export const frameConfigModule = {
    name: 'frameConfigModule',
    initialize,
    getHooks,
};
//# sourceMappingURL=frame-config.js.map